// The prerender Lambda renders auth-gated routes by presenting a known user
// agent. router.js lets it past the requiresAuth guard as a synthetic
// `gusetUser`, so crawlers get real page content instead of a login redirect.
//
// That exemption only ever covered the router guard. Nav's sign-out path ran
// its own `requiresAuth -> router.push('/')` with no such check, so Cognito
// resolving as anonymous a few hundred ms after mount bounced the prerenderer
// back to the home page: the gated route rendered correctly and was then
// thrown away, and crawlers indexed home-page markup under /admix, /g25 and
// /calculators. Anywhere that redirects away from a gated route has to consult
// this, which is why it lives here rather than inline in the guard.
//
// Matching stays exact rather than a `startsWith('Prerender ')` prefix. This
// hands out a synthetic store user and a render of gated routes to anything
// presenting the string, which is not something to grant on a loose match. The
// cost of that choice is that changing the Lambda's user agent silently
// disables the bypass with no error anywhere, so this list has to stay in step
// with the page.setUserAgent() calls in the prerender Lambda's index.js.
export const PRERENDER_USER_AGENTS = [
    `Prerender Mozilla/5.0 (Macintosh; Intel Mac OS X 10_14_0) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/84.0.4147.125 Safari/537.36`,
    `Prerender Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/122.0.0.0 Safari/537.36`,
    `Prerender Mozilla/5.0 (Macintosh; Intel Mac OS X 14_3_1) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/17.3.1 Safari/605.1.15`
]

// Guarded for the SSG build, which evaluates modules in Node with no window.
export function isPrerender() {
    if (typeof window === 'undefined' || !window.navigator || !navigator.userAgent) return false
    return PRERENDER_USER_AGENTS.indexOf(navigator.userAgent) > -1
}

export default isPrerender
